import { createTheme, responsiveFontSizes } from "@mui/material";
import { grey } from "@mui/material/colors";

let DefaultTheme = createTheme({
  typography: {
    fontFamily: '"Montserrat", sans-serif',
  },
  palette: {
    mode: "dark",
    primary: {
      // main: '#bd7935',
      // main: "#bd7935"
      main: "#ad2d2d"
    },
    secondary: {
      main: '#66bb6a',
      // main: "#313131"
// main: '#2054ba',
    },
    background: {
      default: "#1f2028",
      paper: "#181921"
    },
    text2: {
      primary: "#dae0e9",
      secondary: "#c5cbd3"
    }
  },
  components: {
    MuiTextField: {
    defaultProps: {
      variant: "outlined"
    }
  },
  MuiInputBase: {
    styleOverrides: {
      root: {
        backgroundColor: grey[50], // pozadina polja
        borderRadius: 8,
        color: "#303e24", // boja teksta
      },
      input: {
        padding: "12px",
      }
    }
  },
  MuiOutlinedInput: {
    styleOverrides: {
      notchedOutline: {
        borderColor: grey[300]
      },
      root: {
        "&:hover .MuiOutlinedInput-notchedOutline": {
          borderColor: grey[400]
        },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
          borderColor: "#636d7bff",
          borderWidth: "2px"
        }
      }
    }
  },
    MuiContainer: {
      styleOverrides: {
        root: {
          borderRadius: 12
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: ({ownerState}) => ({
          textTransform: "none",
          borderRadius: 12,
          color: ownerState.variant !== 'outlined' ? '#fff' : undefined,
        })
      }
    },
    MuiButtonBase: {
      styleOverrides: {
        root: {
          textTransform: "none",
          borderRadius: 12
        }
      }
    }
  },
  shape: {
    borderRadius: 12
  },
  shadows: [
    "none",
    "rgba(9, 30, 66, 0.25) 0px 4px 6px -5px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px",
    "rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 1px 1px",
    "rgba(9, 30, 66, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px",
    "rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgb(209, 213, 219) 0px 0px 0px 1px inset",
    "0 1px 5px rgb(0 0 0 / 15%)",
    "rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgb(209, 213, 219) 0px 0px 0px 1px inset",
    "rgba(0, 0, 0, 0.05) 0px 0px 0px 1px",
    "rgba(0, 0, 0, 0.05) 0px 0px 0px 1.25px",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
  ]
});

DefaultTheme = responsiveFontSizes(DefaultTheme);

export default DefaultTheme;